module.exports = __webpack_public_path__ + "static/media/MZ_03.610ec821.jpg";